(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-variant-link-sync"]) return;
  try {
    
  class CampaignVariantLinkSync extends HTMLElement {
    connectedCallback() {
      this.grid = document.querySelector('section-variant-grid');
      if (!this.grid) return;

      this.syncLinks = () => {
        this.grid.querySelectorAll('.product-card').forEach((card) => {
          const variantLink = card.querySelector('.product-card__images[href*="variant="]');
          const titleLink = card.querySelector('.product-card__url');

          if (variantLink && titleLink && titleLink.href !== variantLink.href) {
            titleLink.href = variantLink.href;
          }
        });
      };

      this.observer = new MutationObserver(this.syncLinks);
      this.observer.observe(this.grid, {
        attributes: true,
        attributeFilter: ['href'],
        childList: true,
        subtree: true,
      });
      this.syncLinks();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('campaign-variant-link-sync')) {
    customElements.define('campaign-variant-link-sync', CampaignVariantLinkSync);
  }

  } catch(e) { console.error(e); }
})();
})();
